import {
  RESET_CLIENT_SYSTEM_VALUES,
  RESET_CLIENT_SYSTEM_VALUE,
  RESET_ERROR,
  GET_CLIENT_SYSTEM_VALUES,
  SET_CLIENT_SYSTEM_VALUES,
  API_ERROR,
  GET_CLIENT_SYSTEM_VALUE,
  SET_CLIENT_SYSTEM_VALUE,
  CREATE_CLIENT_SYSTEM_VALUE,
  CREATE_CLIENT_SYSTEM_VALUE_SUCCESS,
  EDIT_CLIENT_SYSTEM_VALUE,
  EDIT_CLIENT_SYSTEM_VALUE_SUCCESS,
  DELETE_CLIENT_SYSTEM_VALUE,
  DELETE_CLIENT_SYSTEM_VALUE_SUCCESS,
} from "./actionTypes";

export const resetClientSystems = () => {
  return {
    type: RESET_CLIENT_SYSTEM_VALUES,
    payload: {},
  };
};

export const resetClientSystem = () => {
  return {
    type: RESET_CLIENT_SYSTEM_VALUE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getClientSystems = (
  idCompany,
  page,
  qnt,
  clientId,
  variable,
  value,
  isForm
) => {
  return {
    type: GET_CLIENT_SYSTEM_VALUES,
    payload: { idCompany, page, qnt, clientId, variable, value, isForm },
  };
};
export const setClientSystems = (data, qtdDefault, idCompany) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_CLIENT_SYSTEM_VALUES,
    payload: { ...data, paging, idCompany },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createClientSystem = (newClientSystemValues, idCompany) => {
  return {
    type: CREATE_CLIENT_SYSTEM_VALUE,
    payload: { newClientSystemValues, idCompany },
  };
};
export const createClientSystemSuccess = (message) => {
  return {
    type: CREATE_CLIENT_SYSTEM_VALUE_SUCCESS,
    payload: { message },
  };
};

export const getClientSystem = (idClientSystem, idCompany, isForm) => {
  return {
    type: GET_CLIENT_SYSTEM_VALUE,
    payload: { idClientSystem, idCompany, isForm },
  };
};
export const setClientSystem = (data) => {
  return {
    type: SET_CLIENT_SYSTEM_VALUE,
    payload: { data },
  };
};

export const editClientSystem = (
  idClientSystem,
  newClientSystemValues,
  idCompany
) => {
  return {
    type: EDIT_CLIENT_SYSTEM_VALUE,
    payload: {
      idClientSystem,
      newClientSystemValues,
      idCompany,
    },
  };
};
export const editClientSystemSuccess = (message) => {
  return {
    type: EDIT_CLIENT_SYSTEM_VALUE_SUCCESS,
    payload: { message },
  };
};

export const deleteClientSystem = (idClientSystem, idCompany) => {
  return {
    type: DELETE_CLIENT_SYSTEM_VALUE,
    payload: { idClientSystem, idCompany },
  };
};
export const deleteClientSystemSuccess = (message) => {
  return {
    type: DELETE_CLIENT_SYSTEM_VALUE_SUCCESS,
    payload: { message },
  };
};
